import axios, { axiosV2 } from "@axios"; //eslint-disable-line

export default {
    /*
     * main products API
     */
    getProducts(params = {}) {
        return axios.get('/products', { params });
    },
    getProductsPaginated(params) {
        return axios.get('/products/paginated', { params });
    },
    deleteProduct(uuid) {
        return axios.delete(`/products/${uuid}`);
    },
    addProduct(data, params = {}) {
        return axiosV2.post('/products', data, { params });
    },
    getProduct(uuid, params = {}) {
        return axiosV2.get(`/products/${uuid}`, { params });
    },
    getProductHistory(uuid) {
        return axios.get(`/products/${uuid}/history`);
    },
    updateProduct(uuid, data) {
        return axiosV2.put(`/products/${uuid}`, data);
    },
    updateProductOwner(uuid, data) {
        return axios.put(`/products/${uuid}/owner`, data);
    },
    updateProductImagesSortOrder(data) {
        return axios.put('/products/images/order', data);
    },
    searchProducts(params) {
        return axios.get('/products', { params });
    },
    validateSlug(productUuid, slug) {
        return axios.get('/products/validate-slug', {
            params: {
                uuid: productUuid,
                slug,
            },
        });
    },

    /*
     * admin products API
     */
    getProductsForReview() {
        return axios.get('/products/review');
    },
    updateProductStatus(uuid, product) {
        return axios.put(`/products/${uuid}/review`, product);
    },
    getProductForReview(uuid) {
        return axios.get(`/products/${uuid}/review`);
    },
    getProductRejectReasons() {
        return axios.get('/products/reject-reasons');
    },

    /*
     * categories API
     */
    getCategories(params) {
        return axios.get('/categories', { params });
    },
    getCategoriesPaginated(params) {
        return axios.get('/categories/paginated', { params });
    },
    getCategory(uuid) {
        return axios.get(`/categories/${uuid}`);
    },
    updateCategory(uuid, data) {
        return axios.put(`/categories/${uuid}`, data);
    },
    addCategory(data) {
        return axios.post('/categories', data);
    },

    /*
     * integrations API
     */
    searchIntegrations(searchTerm) {
        return axios.get('/products/integrations/search', {
            params: {
                q: searchTerm,
            },
        });
    },

    /*
     * product images API
     */
    deleteProductImage(productUuid, uuid) {
        return axios.delete(`/products/${productUuid}/images/${uuid}`);
    },
    deleteUsefulResource(usefulResourceUuid) {
        return axios.delete(`/products/images/usefulResources/${usefulResourceUuid}`);
    },
    updateProductScreenshotCaption(uuid, data) {
        return axios.put(`/products/images/${uuid}`, data);
    },
    updateUsefulResource(usefulResourceUuid, data) {
        return axios.put(`/products/images/usefulResources/${usefulResourceUuid}`, data);
    },
    /*
     * features API
     */
    getFeaturesByCategory(categoryUuids) {
        return axios.post('/products/features/filter', categoryUuids);
    },
    /*
     * product prices/industries/companySize API
     */
    getPricingLevels() {
        return axios.get('/products/prices');
    },
    getIndustries() {
        return axios.get('/products/industries');
    },
    getCompanySizes() {
        return axios.get('/products/company_sizes');
    },
    getProductKpis(productUuid, period = 30) {
        return axios.get(`/products/${productUuid}/kpis`, {
            params: {
                period,
            },
        });
    },
    getProductSignals(productUuid, period = 30, params = {}) {
        return axios.get(`/products/${productUuid}/signals`, {
            params: {
                period,
                ...params,
            },
        });
    },

    /*
     * admin user reviews API
     */
    getUserReviews(params = {}) {
        return axios.get('/products/user_review', {
            params,
        });
    },
    getUserReview(uuid) {
        return axios.get(`/products/user_review/${uuid}`);
    },
    updateUserReview(uuid, review) {
        return axiosV2.put(`/products/user_review/${uuid}`, review);
    },
    getSourceFilter(params = {}) {
        return axios.get('/products/user_review/filter/source', {
            params,
        });
    },
    getProductFilter(params = {}) {
        return axios.get('/products/user_review/filter/product', {
            params,
        });
    },
    getRatingFilter() {
        return axios.get('/products/user_review/filter/rating');
    },
};
